import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorHigherDiagram = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M21.75 10.97A1.75 1.75 0 0 0 20 9.22h-1.8a1.75 1.75 0 0 0-1.75 1.75v10c0 .966.783 1.75 1.75 1.75H20a1.75 1.75 0 0 0 1.75-1.75v-10ZM20 10.72a.25.25 0 0 1 .25.25v10a.25.25 0 0 1-.25.25h-1.8a.25.25 0 0 1-.25-.25v-10a.25.25 0 0 1 .25-.25H20ZM14.75 12.97A1.75 1.75 0 0 0 13 11.22h-1.7a1.75 1.75 0 0 0-1.75 1.75v8c0 .966.783 1.75 1.75 1.75H13a1.75 1.75 0 0 0 1.75-1.75v-8ZM13 12.72a.25.25 0 0 1 .25.25v8a.25.25 0 0 1-.25.25h-1.7a.25.25 0 0 1-.25-.25v-8a.25.25 0 0 1 .25-.25H13ZM6.3 14.22c.966 0 1.75.783 1.75 1.75v5a1.75 1.75 0 0 1-1.75 1.75H4.7a1.75 1.75 0 0 1-1.75-1.75v-5c0-.967.783-1.75 1.75-1.75h1.6Zm.25 1.75a.25.25 0 0 0-.25-.25H4.7a.25.25 0 0 0-.25.25v5c0 .138.112.25.25.25h1.6a.25.25 0 0 0 .25-.25v-5Z"
    />
    <path
      fill="#F7A600"
      d="M19.729 2.768a.75.75 0 0 1 .53.918l-.926 3.457a.75.75 0 1 1-1.45-.388l.48-1.786-4.965 3.475a.75.75 0 0 1-.96-.084l-1.08-1.08-6.388 4.502a.75.75 0 0 1-.864-1.226l6.903-4.867a.75.75 0 0 1 .962.083l1.083 1.082 4.465-3.126-1.636-.438a.75.75 0 1 1 .389-1.449l3.457.927Z"
    />
  </svg>
);
export default SvgTwoColorHigherDiagram;
